import React from 'react';
import { Text, View } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';

const InvitationsContent: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Getting players into your tournament used to mean copying bracket links and
      hoping people would sign up. Today that changes: Tournaly now has a full invitation
      system — invite by email, share a code, or send a link. Players join in one tap.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Two ways to invite
    </Text>

    <Text style={{ fontSize: 17, fontWeight: '600', color: colors.text, marginBottom: 8 }}>
      Invite by email
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 16 }}>
      Search for any registered Tournaly user by email from inside your tournament's Settings tab
      and send them a direct invitation. They receive a push notification and can accept or decline
      from the Invitations screen.
    </Text>

    <Text style={{ fontSize: 17, fontWeight: '600', color: colors.text, marginBottom: 8 }}>
      Invite by code
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Every tournament gets an 8-character invite code. Share it anywhere — a WhatsApp group,
      a Discord server, printed on a flyer. Anyone with the code can join via "Join by Code"
      in the drawer, no need to have the link.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Managing your invitations
    </Text>
    {[
      'View all received and sent invitations from the Invitations screen in the drawer',
      'Accept or decline incoming invitations with one tap',
      'Cancel a sent invitation at any time before it is accepted',
      'Pending invitations show a badge count in the navigation drawer',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}
  </View>
);

const InvitationsContentEs: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Meter jugadores en tu torneo antes significaba copiar enlaces y esperar a que la gente
      se apuntara. Hoy eso cambia: Tournaly tiene ahora un sistema completo de invitaciones
      — invita por email, comparte un código, o envía un enlace. Los jugadores se unen con un toque.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Dos formas de invitar
    </Text>

    <Text style={{ fontSize: 17, fontWeight: '600', color: colors.text, marginBottom: 8 }}>
      Invitar por email
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 16 }}>
      Busca a cualquier usuario registrado en Tournaly por email desde la pestaña Ajustes
      de tu torneo y envíale una invitación directa. Recibirá una notificación push y podrá
      aceptar o declinar desde la pantalla de Invitaciones.
    </Text>

    <Text style={{ fontSize: 17, fontWeight: '600', color: colors.text, marginBottom: 8 }}>
      Invitar por código
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Cada torneo tiene un código de invitación de 8 caracteres. Compártelo donde quieras
      — un grupo de WhatsApp, un servidor de Discord, impreso en un flyer. Cualquiera con
      el código puede unirse desde "Unirse por Código" en el menú, sin necesidad del enlace.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Gestionando tus invitaciones
    </Text>
    {[
      'Ver todas las invitaciones recibidas y enviadas desde la pantalla Invitaciones en el menú',
      'Aceptar o declinar invitaciones entrantes con un toque',
      'Cancelar una invitación enviada en cualquier momento antes de que sea aceptada',
      'Las invitaciones pendientes muestran un contador en el menú de navegación',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}
  </View>
);

export const post: BlogPost = {
  slug: '2026-02-12-tournament-invitations',
  title: 'Tournament Invitations: Invite by Email or Code',
  titleEs: 'Invitaciones a Torneos: Invita por Email o Código',
  date: '2026-02-12',
  summary: 'Invite players to your tournament bracket by email search or shareable join code — the easiest way to fill your bracket without manual entry.',
  summaryEs: 'Invita jugadores a tu bracket por email o código de unión compartible — la forma más fácil de llenar tu torneo sin entrada manual.',
  tags: ['Invitations', 'Feature'],
  Content: InvitationsContent,
  ContentEs: InvitationsContentEs,
};
